"use strict";
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
    function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
    function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportToGoogleSheet = exports.importFromGoogleSheet = void 0;
const google_spreadsheet_1 = require("google-spreadsheet");
const xlsx_1 = require("xlsx");
function extractSpreadSheetId(spreadSheetUrl) {
    const match = spreadSheetUrl.match(/https:\/\/docs.google.com\/spreadsheets\/(u\/\d+\/)?d\/([^/]+)/);
    return match === null || match === void 0 ? void 0 : match[2];
}
const GOOGLE_API_INTERVAL = 2000;
function importFromGoogleSheet(accessToken, spreadSheetUrl) {
    return __asyncGenerator(this, arguments, function* importFromGoogleSheet_1() {
        const sheetId = extractSpreadSheetId(spreadSheetUrl);
        if (!sheetId) {
            yield yield __await({ type: "error", message: "シートURLが不正です" });
            return yield __await(void 0);
        }
        try {
            const doc = new google_spreadsheet_1.GoogleSpreadsheet(sheetId, {
                token: accessToken,
            });
            try {
                yield __await(doc.loadInfo());
            }
            catch (error) {
                yield yield __await({ type: "error", message: "シートを読み込めません" });
                return yield __await(void 0);
            }
            const sheetsCount = doc.sheetCount;
            yield yield __await({
                type: "meta",
                fileName: doc.title,
            });
            yield yield __await({
                type: "progress",
                importedSheets: 0,
                totalSheets: sheetsCount,
            });
            const workbook = xlsx_1.utils.book_new();
            for (let i = 0; i < sheetsCount; i++) {
                const sheet = doc.sheetsByIndex[i];
                if (!sheet)
                    continue;
                // column digits length: A = 1, AB = 2, ZZZ = 3
                const columnDigitLength = 1;
                /*
                  This could have been like:
                    const columnDigitLength = Math.ceil(
                      Math.log((Math.max(1, sheet.columnCount) * 2 + 3) / 3) / Math.log(3)
                    );
          
                  But precision was not enough.
                  As I am not an expert, I have assumed the DigitLength = 1 (A~Z)
                 */
                yield __await(sheet.loadCells(`A1:${[...Array(columnDigitLength)].map(() => "Z").join("")}${sheet.rowCount + 10}`));
                const rows = [];
                for (let row = 0; row < sheet.rowCount; row++) {
                    const array = new Array(sheet.columnCount);
                    for (let col = 0; col < sheet.columnCount; col++)
                        array[col] = sheet.getCell(row, col).formattedValue;
                    rows.push(array);
                }
                xlsx_1.utils.book_append_sheet(workbook, xlsx_1.utils.aoa_to_sheet(rows), `Sheet No. ${i + 1}`);
                yield yield __await({
                    type: "progress",
                    importedSheets: i + 1,
                    totalSheets: sheetsCount,
                });
                // Google Sheets API has a rate limit of 100 requests per 100 seconds per user,
                // 500 requests per 100 seconds per project
                yield __await(new Promise((resolve) => setTimeout(resolve, GOOGLE_API_INTERVAL)));
            }
            yield yield __await({ type: "generated", xlsx: workbook });
        }
        catch (error) {
            yield yield __await({
                type: "error",
                message: error instanceof Error ? error.message : String(error),
            });
        }
    });
}
exports.importFromGoogleSheet = importFromGoogleSheet;
function exportToGoogleSheet(accessToken, spreadSheetUrl, workbook) {
    return __asyncGenerator(this, arguments, function* exportToGoogleSheet_1() {
        const sheetId = extractSpreadSheetId(spreadSheetUrl);
        if (!sheetId) {
            yield yield __await({ type: "error", message: "シートURLが不正です" });
            return yield __await(void 0);
        }
        try {
            const doc = new google_spreadsheet_1.GoogleSpreadsheet(sheetId, {
                token: accessToken,
            });
            try {
                yield __await(doc.loadInfo());
            }
            catch (error) {
                yield yield __await({ type: "error", message: "シートを読み込めません" });
                return yield __await(void 0);
            }
            const sheetsCount = workbook.SheetNames.length;
            let exportedSheetCount = 0;
            yield yield __await({
                type: "progress",
                exportedSheets: 0,
                totalSheets: sheetsCount,
            });
            for (const sheetName of workbook.SheetNames) {
                const xlsxSheet = workbook.Sheets[sheetName];
                const rows = xlsx_1.utils.sheet_to_json(xlsxSheet, {
                    header: 1,
                    raw: true,
                });
                if (rows.length === 0)
                    continue;
                const [header, ...rest] = rows;
                const sheet = yield __await(doc.addSheet({
                    title: sheetName,
                    headerValues: header.length === 0 || header.every((v) => !v) ? [sheetName] : header,
                }));
                yield __await(sheet.addRows(rest));
                yield yield __await({
                    type: "progress",
                    exportedSheets: ++exportedSheetCount,
                    totalSheets: sheetsCount,
                });
                // Google Sheets API has a rate limit of 100 requests per 100 seconds per user,
                // 500 requests per 100 seconds per project
                yield __await(new Promise((resolve) => setTimeout(resolve, GOOGLE_API_INTERVAL)));
            }
            yield yield __await({ type: "succeeded" });
        }
        catch (error) {
            yield yield __await({
                type: "error",
                message: error instanceof Error ? error.message : String(error),
            });
        }
    });
}
exports.exportToGoogleSheet = exportToGoogleSheet;
